import { Image, Link } from '@direct-frontend/components';
import yandexLogoSource from './assets/yandexLogo.svg';

export const YandexPayBadge = () => (
    <Link href="https://bank.yandex.ru/pay/" target="_blank">
        <Image width="60" height="20" src={yandexLogoSource} alt="Яндекс Пэй" />
    </Link>
);
